export default function PublicGuard({ children }) {
	return children
}
